// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"153caac2","2947":"11b01132","3893":"465bdacb","7201":"d6f4254a"}[chunkId] + ".chunk.css";
};